import { render, staticRenderFns } from "./add-edit-post.vue?vue&type=template&id=b6cf1d2e&scoped=true&"
import script from "./add-edit-post.vue?vue&type=script&lang=js&"
export * from "./add-edit-post.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-post.vue?vue&type=style&index=0&id=b6cf1d2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cf1d2e",
  null
  
)

export default component.exports